const { Debug } = require('./lib/debug');

module.exports.Debug = Debug;
